//Estilo del sitio
import '../../assets/dist/stilo.css';

//Logos
/* import logo from '../../assets/svg/logo-udd-blanco.svg'; */
import logo from '../../assets/images/UDD-blanco.png';
import logoAcre from '../../assets/images/logo-acreditacion-UDD-blanco.png';

//Iconos
//"/assets/dist/svg/main.svg#twitter"
import twter from '../../assets/dist/svg/main.svg'
///assets/dist/svg/main.svg#facebook
import face from '../../assets/dist/svg/main.svg'
///assets/dist/svg/main.svg#linkedin
import linke from '../../assets/dist/svg/main.svg'
//"/assets/dist/svg/main.svg#youtube"
import tube from '../../assets/dist/svg/main.svg'
///assets/dist/svg/main.svg#instagram
import insta from '../../assets/dist/svg/main.svg'

const Footer = () => {

    return (
        <>
            <footer className='site-footer'>
                <div className="site-footer__corporate">
                    <div className="corporate-image">
                        <img src={logo} alt="Logo Universidad de Desarrollo" className="corporate-image__logo" />
                    </div>
                    <div className="corporate-addresses">
                        <address className="corporate-address">
                            <h3>Sede Santiago</h3>
                            <p>{/* <a href="tel:+56223279110">(+56-2) 2327 9110</a> -  */}Av. Plaza 680, San Carlos de Apoquindo, Las Condes</p>
                            <p><a href='http://www.udd.cl/contacto/'>Contacto</a> | <a href='http://www.udd.cl/infraestructura/donde-estamos/'>Mapa</a></p>
                        </address>
                        <address className="corporate-address">
                            <h3>Sede Concepción</h3>
                            <p>{/* <a href="tel:+56412268610">(+56-41) 226 8610</a> -  */}Ainavillo 456, Concepción</p>
                            <p><a href="http://www.udd.cl/contacto/">Contacto</a> | <a href='http://www.udd.cl/infraestructura/donde-estamos/?sede=concepcion'>Mapa</a></p>
                        </address>
                    </div>
                    <div className="corporate-accreditation">
                        <img src={logoAcre} alt='Logo Acreditación UDD' className='corporate-accreditation__logo' width="224" height="69" />
                    </div>
                </div>

                <div className="site-footer__contact">
                    <div className="container">
                        <div className="site-footer__callcenter">
                            <span className="site-footer__contact__label">Call Center:</span>
                            <a href="tel:800200125" className="site-footer__callcenter__link callCenter">800 200 125</a>
                        </div>
                        <div className="site-footer__networks">
                            <span className="site-footer__contact__label">Encuéntranos en:</span>
                            <nav className="site-footer__rrss">
                                <ul className="nav-rrss">
                                    <li className="social-media__twitter">
                                        <a href="http://twitter.com/udd_cl">
                                            <span className="sr-only">Twitter</span>
                                            <svg className="svg-twitter-dims"><use xlinkHref={twter + "#twitter"}></use></svg>
                                        </a>
                                    </li>
                                    <li className="social-media__facebook">
                                        <a href="http://www.facebook.com/udd.cl">
                                            <span className="sr-only">Facebook</span>
                                            <svg className="svg-facebook-dims"><use xlinkHref={face + "#facebook"}></use></svg>
                                        </a>
                                    </li>
                                    <li className="social-media__linkedin">
                                        <a href="http://www.linkedin.com/company/universidad-del-desarrollo">
                                            <span className="sr-only">LinkedIn</span>
                                            <svg className="svg-linkedin-dims"><use xlinkHref={linke + "#linkedin"}></use></svg>
                                        </a>
                                    </li>
                                    <li className="social-media__youtube">
                                        <a href="http://www.youtube.com/user/viveudd/">
                                            <span className="sr-only">YouTube</span>
                                            <svg className="svg-youtube-dims"><use xlinkHref={tube + "#youtube"}></use></svg>
                                        </a>
                                    </li>
                                    <li className="social-media__instagram">
                                        <a href="http://instagram.com/udd_cl/">
                                            <span className="sr-only">Instagram</span>
                                            <svg className="svg-instagram-dims"><use xlinkHref={insta + "#instagram"}></use></svg>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>

                <div className="corporate-accreditation--md">
                    <img src={logoAcre} alt="Logo Acreditación UDD" className="corporate-accreditation__logo" width="224" height="69" />
                </div>
            </footer>
        </>
    )
}

export default Footer
